<p-toast key="general-message"></p-toast>
<div class="px-4 py-2">
    <a pButton icon="pi pi-angle-left" class="no-underline w-auto" severity="primary" label="Back to Portal" (click)="backToPortal()"></a>
  </div>
<div class="card flex justify-content-center">
    <p-stepper [linear]="true" [activeStep]="activeStep" class="col-12">
        <p-stepperPanel header="Assign Surepark Groups">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">

                <p-table #invoiceTable [value]="missingSureParkGroupMonthlyProfiles"
                    [globalFilterFields]="['lid', 'suite', 'account', 'tenant']" [resizableColumns]="true"
                    responsiveLayout="scroll" [loading]="isLoading || loadingSettings">
                    <ng-template pTemplate="caption">
                        <h4>List of Missing Monthly Profile Groups</h4>
                        <div class="flex align-items-center justify-content-between">
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="invoiceTable.filterGlobal($any($event.target).value, 'contains')"
                                        placeholder="Search..." />
                                </span>
                            </div>
                            <div class="flex gap-2 align-items-center">
                                <p-checkbox [(ngModel)]="syncContactForMatchedGroupOnly" [binary]="true" inputId="sync-contact" />
                                <label for="sync-contact">Sync only contacts matched company</label>
                                <p-dropdown [(ngModel)]="updateGroup" [options]="updateGroupOptions"
                                    appendTo="body" optionLabel="name" optionValue="code" (onChange)="changeTenantGroupNameValidation()">
                                </p-dropdown>
                                <p-autoComplete [(ngModel)]="globalGroupName" placeholder="Search Group"
                                    [dropdown]="true" [forceSelection]="true" [suggestions]="filteredSureParkGroups"
                                    [showClear]="true" appendTo="body" (completeMethod)="filterGroup($event)"
                                    optionLabel="name" optionValue="id" *ngIf="updateGroup == 'UpdateAll'">
                                    <ng-template let-group pTemplate="item">
                                        <div>{{ group.name }}</div>
                                    </ng-template>
                                </p-autoComplete>
                                <p-button severity="success" label="Apply All" (click)="applyToAll()"
                                    [disabled]="savingTenantGroups" *ngIf="updateGroup == 'UpdateAll'"/>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pResizableColumn pSortableColumn="account">
                                Account
                                <p-sortIcon field="account"></p-sortIcon>
                            </th>
                            <th>Tenant</th>
                            <th>Company Name (Group Name)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-invoice let-rowIndex="rowIndex">
                        <tr>
                            <td class="mpi-text-truncate">
                                {{ invoice.suite }} - {{ invoice.account }}
                            </td>
                            <td class="mpi-text-truncate">{{ invoice.tenant }}</td>
                            <td>
                                <div [formGroup]="getTenantGroupNameFormGroup(rowIndex)">
                                    <p-autoComplete placeholder="Search Group" [dropdown]="true" [forceSelection]="true"
                                        formControlName="group" [suggestions]="filteredSureParkGroups"
                                        [showClear]="true" appendTo="body" (completeMethod)="filterGroup($event)"
                                        optionLabel="name">
                                        <ng-template let-group pTemplate="selectedItem">
                                            <div>{{ group.name }}</div>
                                        </ng-template>
                                        <ng-template let-group pTemplate="item">
                                            <div>{{ group.name }}</div>
                                        </ng-template>
                                    </p-autoComplete>
                                    <div
                                        *ngIf="tenantGroupNameFormSubmitted && getTenantGroupNameFormGroup(rowIndex).controls['group'].errors">
                                        <div class="ui-messages-error"
                                            *ngIf="getTenantGroupNameFormGroup(rowIndex).controls['group'].errors?.['required']">
                                            Please select group.
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8" class="text-center"><b>No Data Found.</b></td>
                        </tr>
                    </ng-template>
                </p-table>

                <div class="flex pt-4 justify-content-end">
                    <p-button label="{{ missingSureParkGroupMonthlyProfiles.length ? 'Save Groups' : 'Next Step' }}"
                        icon="pi pi-arrow-right" iconPos="right" [loading]="savingTenantGroups || isLoading || loadingSettings"
                        (onClick)="saveTenantGroupName()" />
                </div>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Sync Incomplete Contacts">
            <ng-template pTemplate="content" let-index="index">
                <div *ngIf="!isProfileContactsLoading; else spinner">
                    <p-table #contactsTable [value]="inCompleteProfileContacts"
                        [globalFilterFields]="['monthly_profile_details.lid', 'monthly_profile_details.suite', 'monthly_profile_details.account', 'contactName']"
                        [resizableColumns]="true" responsiveLayout="scroll" [paginator]="true" [rows]="150"
                        [totalRecords]="inCompleteProfileContacts.length" [loading]="isProfileContactsLoading"
                        dataKey="surepark_member_details.id"
                        rowGroupMode="subheader" dataKey="surepark_member_details.is_keycard_match" groupRowsBy="surepark_member_details.is_keycard_match">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <div class="col-12 sm:col-8 md:col-6 lg:col-3">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="contactsTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pResizableColumn pSortableColumn="monthly_profile_details.account">
                                    Account
                                    <p-sortIcon field="monthly_profile_details.account"></p-sortIcon>
                                </th>
                                <th>Group Name</th>
                                <th>Contact Name</th>
                                <th>Keycard</th>
                                <th>Rate</th>
                                <th>Effective Date</th>
                                <th>Termination Date</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="groupheader" let-contact let-expanded="expanded">
                            <tr>
                                <td colspan="7">
                                    <div class="flex align-items-center">
                                        <button
                                        type="button"
                                        pButton
                                        pRipple
                                        [pRowToggler]="contact"
                                        class="p-button-text p-button-rounded p-button-plain mr-2"
                                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                    </button>
                                    <span class="font-bold ml-2">
                                        <p-badge [value]="getGroupCount(contact.surepark_member_details.is_keycard_match)" [severity]="contact.surepark_member_details.is_keycard_match == 'keycard already matched' ? 'success' : 'danger'"/>
                                         {{contact.surepark_member_details.is_keycard_match | titlecase}}</span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="rowexpansion" let-contact let-rowIndex="rowIndex">
                            <tr>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">
                                    {{ contact.monthly_profile_details.suite }} - {{contact.monthly_profile_details.account }}
                                </td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">{{ contact.monthly_profile_details.groupName }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">{{ contact.contactName }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">{{ contact.facility_code }} / {{ contact.keycards }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">
                                    <div [formGroup]="getContactRateFormGroup(rowIndex)">
                                        <p-dropdown placeholder="Select a rate"
                                            formControlName="rate" [options]="locationSettings.ratesReport.approved"
                                            optionLabel="parkproDescription" optionValue="sureparkID" appendTo="body">
                                            <ng-template let-rate pTemplate="item">
                                                <div>{{ rate.parkproDescription }}</div>
                                            </ng-template>
                                        </p-dropdown>
                                        <div
                                            *ngIf="tenantContactRateFormSubmitted && getContactRateFormGroup(rowIndex).controls['rate'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="getContactRateFormGroup(rowIndex).controls['rate'].errors?.['required']">
                                                Please select rate.
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">{{ contact.effectiveDates }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length" [class.pb-0]="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">{{ contact.terminationDates }}</td>
                            </tr>
                            <tr *ngIf="contact.surepark_member_details?.multiple || contact.surepark_member_details?.missing_details?.length">
                                <td colspan="7" class="pt-0">
                                    <small class="ui-messages-error block ml-0" *ngIf="contact.surepark_member_details?.multiple">
                                        This contact wont get saved due to facility/keycard is exist in multiple contacts
                                        (<span *ngFor="let acct of contact.surepark_member_details?.accounts; let i = index">
                                            <b>{{acct}}</b>{{ contact.surepark_member_details.accounts.length - 1 !== i ? ", " : "" }}
                                         </span>)
                                    </small>
                                    <small class="ui-messages-error block ml-0" *ngIf="filterSureparkMissingDetails(contact.surepark_member_details?.missing_details || []).length">
                                        Following Details are missing/incomplete on surepark contact
                                        (<span *ngFor="let missing_details of filterSureparkMissingDetails(contact.surepark_member_details.missing_details); let i = index">
                                            <b>{{missing_details.detail}}</b>{{ filterSureparkMissingDetails(contact.surepark_member_details.missing_details).length - 1 !== i ? ", " : "" }}
                                         </span>)
                                    </small>
                                    <small class="ui-messages-error block ml-0" *ngIf="filterParkproMissingDetails(contact?.surepark_member_details?.missing_details || [])?.length">
                                        Following Details are missing/incomplete on parkpro contact
                                        (<span *ngFor="let missing_details of filterParkproMissingDetails(contact.surepark_member_details.missing_details); let i = index">
                                            <b>{{missing_details.detail}}</b>{{ filterParkproMissingDetails(contact.surepark_member_details.missing_details).length - 1 !== i ? ", " : "" }}
                                         </span>)
                                    </small>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="8" class="text-center"><b>No Data Found.</b></td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div class="flex pt-4 justify-content-end">
                        <!-- <p-button
                            label="Back"
                            icon="pi pi-arrow-left"
                            (onClick)="prevCallback.emit()" /> -->
                        <p-button label="{{ inCompleteProfileContacts.length ? 'Sync Contacts To SUREPARK' : 'Next Step' }}" icon="pi pi-arrow-right" iconPos="right"
                            (onClick)="syncContactsAutomatic()" [loading]="isSureparkMemberSaving"/>
                    </div>
                </div>
                <ng-template #spinner>
                    <div class="col-12 md:col-8 lg:col-6 md:lg:col-offset-2 lg:col-offset-3">
                        <div class="flex justify-content-between flex-wrap">
                            <h1>Loading Profiles</h1>
                            <!-- <p-button class="my-auto" styleClass="ui-messages-error" severity="danger" label="Cancel process" icon="pi pi-times" [link]="true"/> -->
                        </div>

                        <p-progressBar [value]="profileContactFetchedPercent">
                            <ng-template pTemplate="content" let-value>
                                <span>{{value}}%</span>
                            </ng-template>
                        </p-progressBar>
                        <div class="flex justify-content-between flex-wrap">
                            <h3>{{ allMonthlyProfiles.length }} / {{ totalMonthlyProfilesContactFetched }}</h3>
                            <h3 class="ui-messages-error my-auto">Failed {{ monthlyProfilesContactFetchedFailed.length
                                }}</h3>
                        </div>
                        <p-messages key="profile-contact-error"></p-messages>
                    </div>
                </ng-template>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Sync Missing Contacts">
            <ng-template pTemplate="content" let-index="index">
                    <p-table #contactsTable [value]="missingProfileContacts"
                        [globalFilterFields]="['monthly_profile_details.lid', 'monthly_profile_details.suite', 'monthly_profile_details.account', 'contactName']"
                        [resizableColumns]="true" responsiveLayout="scroll" [paginator]="true" [rows]="150"
                        [totalRecords]="missingProfileContacts.length" [loading]="isProfileContactsLoading">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <div class="col-12 sm:col-8 md:col-6 lg:col-3">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="contactsTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pResizableColumn pSortableColumn="monthly_profile_details.account">
                                    Account
                                    <p-sortIcon field="monthly_profile_details.account"></p-sortIcon>
                                </th>
                                <th>Group Name</th>
                                <th>Contact Name</th>
                                <th>Facility code</th>
                                <th>Keycard</th>
                                <th>Rate</th>
                                <th>Effective Date</th>
                                <th>Termination Date</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-contact let-rowIndex="rowIndex">
                            <tr>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">{{ contact.monthly_profile_details.suite }} - {{ contact.monthly_profile_details.account }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">{{ contact.monthly_profile_details.groupName }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">{{ contact.contactName }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">
                                    <div [formGroup]="getMissingContactRateFormGroup(rowIndex)">
                                        <input pInputText placeholder="Enter facility code" id="facility_code" formControlName="facility_code" />
                                    </div>
                                </td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">{{ contact.keycards }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">
                                    <div [formGroup]="getMissingContactRateFormGroup(rowIndex)">
                                        <p-dropdown placeholder="Select a rate"
                                            formControlName="rate" [options]="locationSettings.ratesReport.approved"
                                            optionLabel="parkproDescription" optionValue="sureparkID" appendTo="body">
                                            <ng-template let-rate pTemplate="item">
                                                <div>{{ rate.parkproDescription }}</div>
                                            </ng-template>
                                        </p-dropdown>
                                        <div
                                            *ngIf="tenantMissingContactRateFormSubmitted && getMissingContactRateFormGroup(rowIndex).controls['rate'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="getMissingContactRateFormGroup(rowIndex).controls['rate'].errors?.['required']">
                                                Please select rate.
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">{{ contact.effectiveDates }}</td>
                                <td class="mpi-text-truncate" [class.border-none]="contact.surepark_member_details?.multiple" [class.pb-0]="contact.surepark_member_details?.multiple">{{ contact.terminationDates }}</td>
                            </tr>
                            <tr *ngIf="contact.surepark_member_details?.multiple">
                                <td colspan="7" class="pt-0">
                                    <small class="ui-messages-error block ml-0">
                                        This contact wont get saved due to facility/keycard is exist in multiple contacts
                                        (<span *ngFor="let acct of contact.surepark_member_details?.accounts; let i = index">
                                            <b>{{acct}}</b>{{ contact.surepark_member_details.accounts.length - 1 !== i ? ", " : "" }}
                                         </span>)
                                    </small>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="8" class="text-center"><b>No Data Found.</b></td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div class="flex pt-4 justify-content-end">
                        <!-- <p-button
                            label="Back"
                            icon="pi pi-arrow-left"
                            (onClick)="prevCallback.emit()" /> -->
                        <p-button label="Create Contacts To SUREPARK" icon="pi pi-arrow-right" iconPos="right"
                            (onClick)="syncMissingContacts()" [loading]="isSureparkMemberSaving"/>
                    </div>
            </ng-template>
        </p-stepperPanel>
    </p-stepper>
</div>

<div class="footer-version">Version: {{version}} {{activeFile}}</div>
